// src/routes/statistics/report/components/TableComponent.js

import React from 'react';

const TableComponent = ({ displayedData, viewMode, ivList }) => {
  if (!displayedData || !displayedData.labels) {
    return <p>데이터가 없습니다.</p>;
  }

  const isIrr = (label = '') => label.includes('일사량');
  const isTemp = (label = '') => label.includes('온도');
  const isEnergy = (label = '') => !(isIrr(label) || isTemp(label));

  const headerUnit = (label) => {
    if (isIrr(label)) return '(W/m²)';
    if (isTemp(label)) return '(℃)';
    return '(kWh)';
  };

  const formatCell = (label, value) => {
    const v = value ?? 0;
    if (isIrr(label)) return `${Number(v).toFixed(0)} W/m²`;
    if (isTemp(label)) return `${Number(v).toFixed(1)} ℃`;
    return `${(Number(v) / 1000).toFixed(2)} kWh`;
  };

  const totalCapacity = (ivList?.iv_capa || []).reduce(
    (sum, capa) => sum + (capa || 0),
    0
  );

  const rowSumsWh = displayedData.labels.map((_, rowIndex) =>
    displayedData.datasets.reduce((sum, ds) => {
      if (!isEnergy(ds.label)) return sum;
      const val = ds.data?.[rowIndex] ?? 0;
      return sum + val;
    }, 0)
  );

  const rowGenerationHours = rowSumsWh.map((sumWh) =>
    totalCapacity > 0 ? sumWh / 1000 / totalCapacity : 0
  );

  const columnSumsDisplay = displayedData.datasets.map((ds) => {
    if (!isEnergy(ds.label)) return '';
    const sumWh = (ds.data || []).reduce((s, v) => s + (v ?? 0), 0);
    return `${(sumWh / 1000).toFixed(2)} kWh`;
  });

  const totalGenerationHours =
    totalCapacity > 0
      ? rowSumsWh.reduce((s, v) => s + v, 0) / 1000 / totalCapacity
      : 0;

  const rowSumKWhDisplay = (rowIndex) =>
    `${(rowSumsWh[rowIndex] / 1000).toFixed(2)} kWh`;

  const grandTotalKWhDisplay = `${(
    rowSumsWh.reduce((s, v) => s + v, 0) / 1000
  ).toFixed(2)} kWh`;

  return (
    <div className="table-container">
      <table className="styled-table">
        <thead>
          <tr>
            <th>날짜</th>
            {displayedData.datasets.map((ds, idx) => (
              <th key={idx}>
                {ds.label} {headerUnit(ds.label)}
              </th>
            ))}
            <th>발전시간 (h)</th>
            {viewMode === 'individual' && <th>합계 (kWh)</th>}
          </tr>
        </thead>
        <tbody>
          {displayedData.labels.map((label, rowIndex) => (
            <tr key={rowIndex}>
              <td>{label}</td>
              {displayedData.datasets.map((ds, colIndex) => (
                <td key={colIndex}>
                  {formatCell(ds.label, ds.data?.[rowIndex])}
                </td>
              ))}
              <td>
                <strong>{rowGenerationHours[rowIndex].toFixed(2)} h</strong>
              </td>
              {viewMode === 'individual' && (
                <td>
                  <strong>{rowSumKWhDisplay(rowIndex)}</strong>
                </td>
              )}
            </tr>
          ))}
          <tr className="total-row">
            <td>
              <strong>합계</strong>
            </td>
            {columnSumsDisplay.map((txt, idx) => (
              <td key={idx}>
                <strong>{txt}</strong>
              </td>
            ))}
            <td>
              <strong>{totalGenerationHours.toFixed(2)} h</strong>
            </td>
            {viewMode === 'individual' && (
              <td>
                <strong>{grandTotalKWhDisplay}</strong>
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;